<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <ref-e-i-table :mode="'compact'"  :value="value" @input="setValue" @onCloseWindow="doClose"></ref-e-i-table>
  </v-dialog>
</template>

<script>
import RefEITable from '@/components/modules/references/refMULocalTable'

export default {
  name: 'refSelectFuelTypeDialog',
  components: { RefEITable },
  props: ['EI', 'value'],
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    setValue (val) {
      this.$emit('onEIChanged', val)
      this.doClose()
    },
    doClose () {
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('refEISelectDialog mounted with EI ', this.EI)
  }
}
</script>
